import { Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useState } from 'react';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

type CopyButtonProps = {
  copyText: string;
};

export const CopyButton = ({ copyText }: CopyButtonProps) => {
  const { t: tCommons } = useTranslationWithLang('commons');
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);
  const handleCopyPath = () => {
    navigator.clipboard.writeText(copyText);
    setShowCopyTooltip(true);
    setTimeout(() => {
      setShowCopyTooltip(false);
    }, 2000);
  };
  return (
    <div className="relative inline-block">
      <Tooltip
        open={showCopyTooltip}
        title={tCommons('TU000_086')}
        placement="top"
        arrow
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: 'var(--c-text)',
              color: 'var(--c-background2)',
              opacity: 0.8,
            },
          },
          arrow: {
            sx: {
              color: 'var(--c-text)',
            },
          },
        }}
      >
        <button
          onClick={handleCopyPath}
          className="cursor-pointer text-[--c-textinput-label] hover:opacity-70"
          title={tCommons('TU000_087')}
          type="button"
          id="copy-button"
          aria-label={tCommons('TU000_087')}
        >
          <ContentCopyIcon fontSize="small" />
        </button>
      </Tooltip>
    </div>
  );
};
